// extracted by mini-css-extract-plugin
export default {"uploadCSVButtonParent":"CreateCategory_uploadCSVButtonParent__d5VBg"};